export const ANALYST_PRIMARY_STEP_KEYS = {
  JOB_INFORMATION: 'jobInformation',
  MILESTONES: 'milestones',
  WORK_PROGRESS: 'workProgress',
  COMPLETED: 'completed',
};

export const ANALYST_PRIMARY_STEPS = [
  { label: 'Job Information', key: ANALYST_PRIMARY_STEP_KEYS.JOB_INFORMATION },
  { label: 'Milestones', key: ANALYST_PRIMARY_STEP_KEYS.MILESTONES },
  { label: 'Work Progress', key: ANALYST_PRIMARY_STEP_KEYS.WORK_PROGRESS },
  { label: 'Completed', key: ANALYST_PRIMARY_STEP_KEYS.COMPLETED },
];

export const WORK_PROGRESS_STEP_KEYS = {
  ASSIGN: 'assign',
  IN_PROGRESS: 'inProgress',
  APPROVAL: 'approval',
};

export const WORK_PROGRESS_STEPS = [
  { label: 'Assign Work', key: WORK_PROGRESS_STEP_KEYS.ASSIGN },
  { label: 'In Progress', key: WORK_PROGRESS_STEP_KEYS.IN_PROGRESS },
  { label: 'Work Approval', key: WORK_PROGRESS_STEP_KEYS.APPROVAL },
];
